<template>
    <div class="main-product__product-details-container" >
        <div class="container main-product__product-details">
            <div class="grid main-product__product-details-grid">
                <div class="col xs-span m6 l6 main-product__product-details-image">
                    <responsive-image
                        v-if="prodimage"
                        class="product-highlights-drawer__image"
                        :image="{
                            src: prodimage
                            }"
                        ratio="3:2"
                     />
                     <responsive-image
                       v-else
                        class="product-highlights-drawer__image"
                        :image="{
                            src: noimage
                            }"
                        ratio="3:2"
                     />
                </div>
                <div class="col xs-span m6 l6"> 
                  <ul class="tabs">
                    <li data-tab-target="#description" class="active tab text-heading-s text-heading-m-desktop"><h3>{{ $string('product.sidebar.description')}}</h3></li>
                    <li data-tab-target="#included" class="tab text-heading-s text-heading-m-desktop"><h3>{{ $string('product.sidebar.included') }}</h3></li>
                    <li v-for="(accordion, index) of additionalAccordion"
                    :key="index" data-tab-target="#needhelp" class="tab text-heading-s text-heading-m-desktop"><h3>{{ accordion.title }}</h3></li>
                  </ul>
                  <div class="tab-content">
                      <div  id="description" data-tab-content class="active">
                        <div class="rte" v-html="product.description" />
                      </div>
                      <div  id="included" data-tab-content>
                        <div class="rte" v-html="product.included" />
                      </div>
                      <div  id="needhelp" data-tab-content>
                        <div  v-for="(accordion, index) of additionalAccordion" class="rte" v-html="accordion.content" />
                      </div>
                  </div>

                </div>
            </div>
        
        </div>
    </div>
  </template>
  
  <script>
import MainProductSidebarUsp from './main-product-sidebar-usp'
import TransitionHeight from '~async/transition-height/transition-height'
import Btn from '~global/btn/btn'
import IconMinus from '~icons/directional-navigation/minus.svg'
import IconPlus from '~icons/directional-navigation/plus.svg'
import ProductStat from '~global/product-stat/product-stat'
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'ProductDetails',
  components: {
    TransitionHeight,
    Btn,
    ResponsiveImage,
    ProductStat,
  },
  props: {
    liquid: {
      type: Object,
      default: () => ({
        description: '',
        price: 0,
        title: '',
      }),
    },
    prodimage :{
      type: String ,
      default:''
    },
    product: {
      type: [Boolean, Object],
      default: false,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
    needHelp:{
        type: String ,
      default:''
    }
  },

  data() {
    return {
      techSpecsData: [
        {
          label: this.$string('compare.log_diameter'),
          value: 'logDiameter',
          unit: this.$string('compare.log_diameter_unit'),
          desc: 'logDiameterTooltip',
        },
        {
          label: this.$string('compare.width_of_cut'),
          value: 'widthOfCut',
          unit: this.$string('compare.width_of_cut_unit'),
          desc: 'boardWidthTooltip',
        },

        {
          label: this.$string('compare.max_horsepower'),
          value: 'maxHorsepower',
          unit: this.$string('compare.max_horsepower_unit'),
          desc: 'maxHorsepowerTooltip',
        },
      ],
      noimage : cnvs.urls.assets.replace('placeholder', `no-image.jpg`),
  
    }
  },

  computed: {
    /**
     * Compute tech specs.
     */
    techSpecs() {
      const techSpecs = []

      this.techSpecsData.forEach((spec) => {
        if (this.product[spec.value] || this.liquid[spec.value]) {
          techSpecs.push(spec)
        }
      })

      return techSpecs
    },
    additionalAccordion() {
      const accordionObjects = []
      // eslint-disable-next-line prefer-named-capture-group
      const regex = /<h(\d)>(.*?)<\/h\1>(.*?)?(?=<h\d>|<\/div>)/gs
      let match
      while ((match = regex.exec(this.liquid.additionalAccordions)) !== null) {
        const title = match[2]
        const content = match[3]
        accordionObjects.push({ title, content })
      }

      return accordionObjects
    },
    /**
     * Compute additional accordion.
     * - Parses a single richtext string into an array of objects that will
     * be used to render multiple separate accordions.
     */

  },

  mounted() {
    // not empty

    const tabs = document.querySelectorAll('[data-tab-target]')
    const tabContents = document.querySelectorAll('[data-tab-content]')

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = document.querySelector(tab.dataset.tabTarget)
        tabContents.forEach(tabContent => {
          tabContent.classList.remove('active')
        })
        tabs.forEach(tab => {
          tab.classList.remove('active')
        })
        tab.classList.add('active')
        target.classList.add('active')
      })
    })
  },

  methods: {
  },
}
</script>